import styles from './waterproof.module.css';
import DOMPurify from 'dompurify';
const Waterproof = ({ textData }) => {
  return (
    <div className={styles.ctn}>
      <div className={styles.textBox}>
        <svg
          width="64"
          height="64"
          viewBox="0 0 64 64"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_585_1280)">
            <path
              d="M29.0666 13.0842C41.1938 14.238 50.6666 24.0581 50.6666 35.9993V38.3024H29.0666V52.1206C29.0666 53.3422 29.5723 54.5137 30.4725 55.3775C31.3727 56.2413 32.5936 56.7266 33.8666 56.7266C35.1397 56.7266 36.3606 56.2413 37.2607 55.3775C38.1609 54.5137 38.6666 53.3422 38.6666 52.1206V49.8175H43.4666V52.1206C43.4666 54.5638 42.4552 56.9069 40.6549 58.6345C38.8545 60.3621 36.4127 61.3327 33.8666 61.3327C31.3205 61.3327 28.8787 60.3621 27.0784 58.6345C25.2781 56.9069 24.2666 54.5638 24.2666 52.1206V38.3024H2.66663V35.9993C2.66663 24.0581 12.1394 14.238 24.2666 13.0842V12.969C24.2666 12.3582 24.5195 11.7725 24.9696 11.3406C25.4197 10.9087 26.0301 10.666 26.6666 10.666C27.3031 10.666 27.9136 10.9087 28.3637 11.3406C28.8138 11.7725 29.0666 12.3582 29.0666 12.969V13.0842Z"
              fill="#3DCCCC"
            />
            <path
              opacity="0.4"
              d="M59.3334 16L51.3334 24"
              stroke="#3DCCCC"
              stroke-width="4"
            />
            <path
              opacity="0.4"
              d="M56.6667 5.66016L46 16.3268"
              stroke="#3DCCCC"
              stroke-width="4"
            />
            <path
              opacity="0.4"
              d="M44.1439 5.33398L38.8105 10.6673"
              stroke="#3DCCCC"
              stroke-width="4"
            />
          </g>
          <defs>
            <clipPath id="clip0_585_1280">
              <rect width="64" height="64" fill="white" />
            </clipPath>
          </defs>
        </svg>

        <h1
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(textData['text35']),
          }}
        ></h1>
        <h5
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(textData['text36']),
          }}
        ></h5>
        <h6
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(textData['text37']),
          }}
        ></h6>
      </div>

      <img className={styles.img} src="http://zhiyun-website-shenzhen.oss-cn-shenzhen.aliyuncs.com/detail/ozone-speaker/zhiyunlife-ozonespeaker-water.jpg"></img>
    </div>
  );
};

export default Waterproof;
